import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import axios from "axios";
import _ from "lodash";
import moment from "moment-timezone";

import PaginationControl from "components/tools/pagination-control";
import { Breadcrumb, Container, RowWrapper } from "components/ui-kit/styled-templates";
import Table from "components/ui-kit/table";

import EventsApi from "api/events-api";
import UniversityApi from "api/university-api";

import { stringImposition } from "services/common-service";
import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import usePagination from "hooks/usePagination";
import { useStorageListener } from "hooks/useStorage";
import RoomChatPanel from "../chat/panels/RoomChatPanel";
import { Sidebar } from "arui-feather/sidebar";
import { ERoles } from "../../types/enums";

const EvenetRequestsPage = () => {
    const { t } = useTranslation();

    useBodyBackground(`white`);
    const bookings = useStorageListener(`bookings`, {});
    const dormitories = useStorageListener(`dormitories`, []);

    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);

    const myUniversityId = useStorageListener(`myUniversityId`, ``);
    const requests = useStorageListener(`events-requests`, []);
    const events = useStorageListener(`events`, []);

    const [selectedChatId, setSelectedChatId] = useState(undefined);
    const eventsBookings = useStorageListener(`events-requests`, {});
    const universities = useStorageListener(`universities`, {});
    let allBookings = {...bookings, ...eventsBookings};

    const selectedChatBooking = (selectedChatId == undefined) ? undefined : allBookings[selectedChatId];
    // console.log('render: allBookings = ', allBookings);
    // console.log('render: selectedChatBooking = ', selectedChatBooking);
    let selectedChatDormitoryId = selectedChatBooking?.dormitoryId;
    // console.log('render: selectedChatDormitoryId = ', selectedChatDormitoryId);
    let selectedChatDormitory = (selectedChatDormitoryId == undefined) ? undefined : dormitories[selectedChatDormitoryId];
    let selectedChatUni = (selectedChatDormitory == undefined) ? undefined : universities[selectedChatDormitory?.universityId];
    // console.log('selectedChatDormitory = ', selectedChatDormitory);
    let selectedChatDormitoryCommittee = selectedChatDormitory?.details?.rules?.committee;
    // console.log('selectedChatDormitoryCommittee = ', selectedChatDormitoryCommittee);
    // console.log('selectedChatUni = ', selectedChatUni);

    const filters = useStorageListener((state) => _.get(state, `tables.requests.filters`) ?? {});
    const filterRows = (rows = []) => {
        return rows?.filter?.((i) => {
            return (
                Object.keys(_.pickBy(filters, _.identity)).length === 0 ||
                Object.entries(_.pickBy(filters, _.identity))
                    ?.map?.(([key, value], index) => !value || stringImposition(_.get(i, key), value))
                    ?.reduce?.((a, b) => a && b, true)
            );
        });
    };



    let isClubAdmin = (role == ERoles.ClubsUniAdmin);

    const paginationResult = usePagination(
        filterRows(
            _.values(requests).filter(x => (isClubAdmin == false || (x.clubId != undefined)))
                // .map(i => ({...i, creationDateString: moment(i.timestamp).format('DD.MM.YYYY HH:mm:ss')}))
                .map(i => ({...i, xNum: `${Math.floor((i.timestamp - 1640995200000) / 1000.0)}`.padStart(9, '0'), creationDateString: moment(i.timestamp).format('DD.MM.YYYY HH:mm:ss')}))
                .sort((a, b) => {
                    return (+b.timestamp - +a.timestamp)
                })
                .filter((i) => i.universityId === myUniversityId)
                .map((i) => ({ ...i, eventName: _.get(events, `${i.eventId}.details.name`) })) as any,
        ),
        { perPage: 10 },
    );
    const { visibleItems } = paginationResult;
    console.log('1: paginationResult = ', paginationResult);

    // @ts-ignore
    useEffect(EventsApi.getEvents, [myUniversityId]);
    // @ts-ignore
    useEffect(() => EventsApi.getBookings(myUniversityId), [myUniversityId]);
    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);

    let sortedVisibleItems = visibleItems.sort((a, b) => {
        return (+b.timestamp - +a.timestamp)
    });


    return (
        <Container extra={`align-items: flex-start;`}>
            <Breadcrumb.Wrapper>
                <Breadcrumb.Item to="/">{t("f6x4y1uzqbk")}</Breadcrumb.Item>
            </Breadcrumb.Wrapper>
            <RowWrapper extra={`h1 { margin: 0; };`}>
                <h1>{t("umt4yxgp3ic")}</h1>
            </RowWrapper>
            <Table
                name="requests"
                withPagination={false}
                columns={[
                    { name: `xNum`, label: `Номер`, extra: `flex: 1.5;` },
                    { name: `creationDateString`, label: `Дата подачи`, extra: `flex: 1.5;` },
                    {
                        name: `details.fullName`,
                        label: `Кто`,
                        extra: `flex: 3;`,
                        onCellClick: ({ row }) => {
                            ModalsService.showModality({
                                title: `Контактная информация`,
                                description: (
                                    <>
                                        <div>
                                            <strong>{t("mi1b9hgwwk")}</strong>: {_.get(row, "details.fullName")}
                                        </div>
                                        <div>
                                            <strong>{t("qqyy5onr2i")}</strong>: {_.get(row, "details.phone")}
                                        </div>
                                        <div>
                                            <strong>Email</strong>: {_.get(row, "details.email")}
                                        </div>
                                    </>
                                ),
                                cancelButton: {
                                    visible: false,
                                },
                                confirmButton: {
                                    children: `ОК`,
                                },
                            });
                        },
                    },
                    {
                        name: `date`,
                        label: `Период бронирования`,
                        extra: `flex: 2;`,
                        transform: ({ row }) => `${moment(_.get(row, `createdTimestamp`)).format(`DD.MM.YYYY`)}`,
                    },
                    {
                        name: `status`,
                        label: `Статус`,
                        cell: { type: `statusLabel`, onChange: EventsApi.updateBooking },
                        extra: `flex: 1.5; justify-content: center;`,
                        transform: (d) => d.value,
                        sortable: false
                    },
                    { name: `eventName`, label: `Событие`, extra: `flex: 3;` },

                    {
                        name: `chat`, label: `Чат`, extra: `flex: 3;`,
                        cell: {
                            type: "chat",
                            messagesNumber: 2,
                            // transform: (d) => d,
                            onClick: a => {
                                console.log('onClick: a = ', a);
                                // window.alert('a.id ' + a.id);
                                setSelectedChatId(a.id);
                            }
                        }
                    },

                    { name: `details.quantity`, label: `Количество`, extra: `flex: 1; justify-content: center;` },
                    {
                        name: `details.needsAccommodation`,
                        label: `Размещение`,
                        extra: `flex: 1; justify-content: center;`,
                        transform: ({ value }) => value ? '✓ Да' : '—',
                    },
                    {
                        name: `requestsMoreButton`,
                        label: ``,
                        extra: `width: 30px; flex: unset;`,
                        cell: {
                            type: `menu`,
                            options: [
                                {
                                    label: `Редактировать`,
                                    onClick: ({ row, navigate }) => navigate(`/edit-event-booking/${row.id}`),
                                },
                                {
                                    label: `Полная информация`,
                                    onClick: ({ row, navigate }) => navigate(`/event-request-preview/${row.id}`),
                                },
                                {
                                    label: `Удалить бронь`,
                                    onClick: ({ row, navigate }) => {
                                        console.log("deleting: row = ", row);
                                        axios.delete(`/event-bookings/${row.id}`).then(() => {
                                            window.location.reload();
                                        });
                                    },
                                },
                                // {
                                //     label: `Удалить бронь`,
                                //     extra: ({ theme }) => `color: ${theme.red};`,
                                //     onClick: ({ row }) => {
                                //         ModalsService.showModality({
                                //             title: `Удаление бронирования`,
                                //             description: `Вы уверены, что хотите удалить это бронирование?`,
                                //             cancelButton: {
                                //                 children: `Отмена`,
                                //                 background: `gray`,
                                //             },
                                //             confirmButton: {
                                //                 children: `Удалить`,
                                //                 background: `red`,
                                //                 onClick: async () => await EventsApi.deleteBooking(row?.id),
                                //             },
                                //         });
                                //     },
                                // },
                            ],
                        },
                    },
                ]}
                rows={sortedVisibleItems}
                extra={`margin-top: 56px;`}
            />

            <PaginationControl pagination={paginationResult} />

            <Sidebar visible={(selectedChatId != undefined)} onCloserClick={() => {
                setSelectedChatId(undefined);
            }}>

                {selectedChatId == undefined ? null :
                    <div>
                        {/*<h2 style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}} >*/}
                        {/*    <span>*/}
                        {/*        Чат*/}
                        {/*    </span>*/}
                        {/*</h2>*/}
                        {/*{selectedChatDormitoryCommittee == undefined ? null :*/}
                        {/*    <div style={{fontSize: '12px'}} >*/}

                        {/*        <b>{selectedChatUni?.details?.name}</b>*/}
                        {/*        <br/>*/}

                        {/*        {selectedChatDormitoryCommittee.name}*/}
                        {/*        <br/>*/}

                        {/*        {`${selectedChatDormitoryCommittee.phone} , ${selectedChatDormitoryCommittee.email}`}*/}
                        {/*    </div>*/}
                        {/*}*/}
                        <div style={{ height: "calc(100vh - 50px)", maxHeight: `calc(100vh - 50px)`, overflowY: "hidden", marginTop: '15px' }}>
                            <RoomChatPanel
                                status={selectedChatBooking?.status}
                                roomId={selectedChatId} />
                        </div>
                    </div>
                }

            </Sidebar>

        </Container>
    );
};

export default EvenetRequestsPage;
